export class PricingInfoDetail {
    containCurrentSubscription: boolean;
    subscriptionTitle: string;

    constructor(subscriptionTitle: string) {
        this.subscriptionTitle = subscriptionTitle;
    }
}

export class PricingInfo extends PricingInfoDetail {
    lines: string[];

    constructor(subscriptionTitle: string, lines: string[]) {
        super(subscriptionTitle);
        this.lines = lines;
    }
}

export class MergePricingInfo {
    pricingInfoDetails: PricingInfoDetail[];
    lines: string[];

    constructor(pricingInfoDetail: PricingInfoDetail, lines: string[]) {
        this.pricingInfoDetails = [pricingInfoDetail];
        this.lines = lines;
    }
}
